<template>
  <div>
    <b-form-select
      v-if="!layoutAsGrid"
      v-model="hours"
      :options="hourOptions"
      :disabled="disabled"
      :size="size"
      class="d-inline-block"
      style="width: 48%;"
    ></b-form-select>
    <b-form-select
      v-if="!layoutAsGrid"
      v-model="minutes"
      :options="minuteOptions"
      :disabled="disabled"
      :size="size"
      class="d-inline-block"
      style="width: 48%;"
    ></b-form-select>
    <b-row v-if="layoutAsGrid">
      <b-col>
        <b-form-select
          v-model="hours"
          :options="hourOptions"
          :disabled="disabled"
          :size="size"
        ></b-form-select>
      </b-col>
      <b-col>
        <b-form-select
          v-model="minutes"
          :options="minuteOptions"
          :disabled="disabled"
          :size="size"
        ></b-form-select>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  function getHours(duration) {
    if (!duration) return 0
    return Math.floor(duration/60)
  }

  function getMinutes(duration) {
    if (!duration) return 0
    return duration % 60
  }

  export default {
    props: {
      value: Number, // minutes
      maxHours: {
        type: Number,
        default: 12,
      },
      size: {
        type: String,
        default: 'md',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      layoutAsGrid: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        trans: trans,
        hours: getHours(this.value),
        minutes: getMinutes(this.value),
      }
    },
    computed: {
      hourOptions() {
        let options = []
        for (let i = 0; i <= this.maxHours; i++)
          options.push({
            value: i,
            text: `${i}h`
          })
        return options
      },
      minuteOptions() {
        let options = []
        for (let i = 0; i <= 59; i++)
          options.push({
            value: i,
            text: `${i}m`
          })
        return options
      },
      serialized() {
        return this.hours * 60 + this.minutes
      },
    },
    watch: {
      value() {
        if (this.value != this.serialized) {
          this.hours = getHours(this.value)
          this.minutes = getMinutes(this.value)
        }
      },
      hours() {
        if (this.value != this.serialized)
          this.$emit('input', this.serialized)
      },
      minutes() {
        if (this.value != this.serialized)
          this.$emit('input', this.serialized)
      },
    },
  }
</script>